import { Configuration, CvuApi } from '@conacyt/perfil-usuario-client';

const perfilConfiguration = new Configuration({
  basePath: '/services/msperfil/api',
});

const perfilUsuarioApi = new CvuApi(perfilConfiguration);

export { perfilUsuarioApi };
